import { useEffect, useReducer } from "react";

// In-memory cache of locally-picked group images, keyed by groupId. Lives only
// for the current session — refreshes drop it. The point is to show the new
// image instantly across every screen until the backend finishes resizing and
// bumps `groups/{id}.photoUpdatedAt`, after which the cache-busted remote URL
// serves the real thumbnail.
const overrides = new Map<string, string>();
const subscribers = new Set<() => void>();

const notify = () => {
  for (const cb of subscribers) cb();
};

export const setGroupImageOverride = (groupId: string, uri: string): void => {
  if (!groupId || !uri) return;
  overrides.set(groupId, uri);
  notify();
};

export const clearGroupImageOverride = (groupId: string): void => {
  if (!overrides.has(groupId)) return;
  overrides.delete(groupId);
  notify();
};

export const useGroupImageOverride = (
  groupId: string | undefined | null,
): string | undefined => {
  const [, force] = useReducer((x: number) => x + 1, 0);
  useEffect(() => {
    subscribers.add(force);
    return () => {
      subscribers.delete(force);
    };
  }, []);
  return groupId ? overrides.get(groupId) : undefined;
};
